import React from 'react';

const AppHeader = () => (<h1>SOS Animal</h1>);

export default AppHeader;
